var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FormField',{staticClass:"field-checkbox",attrs:{"disabled":_vm.disabled,"identifier":_vm.identifier,"label":_vm.label,"label-is-path":_vm.labelIsPath,"has-info":_vm.hasInfo},on:{"info-click":function($event){return _vm.infoClick()}}},[_vm._t("icon"),_vm._t("default",[_c('input',{ref:"input",attrs:{"type":"checkbox","name":_vm.identifier,"id":_vm.identifier},domProps:{"value":1,"checked":false},on:{"click":function (e) {
          if (_vm.disabled) {
            e.target.checked = _vm.checked;
            return;
          }
          _vm.$emit('activate');
          e.target.checked = false;
        }}})])],2)}
var staticRenderFns = []

export { render, staticRenderFns }